<p-table [value]="paginationResult.entities" [lazy]="true" (onLazyLoad)="loadData($event)"
    [rows]="paginationRequest.pageSize" [totalRecords]="paginationResult.filteredEntities"
    [rowsPerPageOptions]="[10,20,30,40,50]" [paginator]="true" [(selection)]="selectedEntities" [loading]="loading"
    [rowHover]="true" [showCurrentPageReport]="true" dataKey="name"
    currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}" class="custom-table"
    styleClass="p-datatable-striped">

    <!-- #region TABLE TITLE DEFINITION -->
    <ng-template pTemplate="caption">
        <div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
            {{ 'tableManagement.sinister.sinisterObservations' | translate }}
        </div>
    </ng-template>
    <!-- #endregion TABLE TITE DEFINITION -->

    <!-- #region TABLE COLUMN DEFINITION -->
    <ng-template pTemplate="header">
        <tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">

            <!-- DESCRIPTION -->
            <th pSortableColumn='description'>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{ 'general.description' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class='d-flex align-items-center h-100'>
                        <p-sortIcon field='description'></p-sortIcon>
                        <p-columnFilter field='description' type='text' matchMode='contains'
                            placeholder="{{ 'general.search' | translate }}" display='menu' [showMatchModes]='false'
                            [showOperator]='false' [showAddButton]='false'></p-columnFilter>
                    </div>

                </div>
            </th>

            <!-- ACTIVE -->
            <th pSortableColumn='date'>
                <div class='d-flex align-items-center h-100'>

                    <!-- COLUMN TITLE -->
                    <div class='d-flex align-items-center align-items-center justify-content-center flex-fill h-100'>
                        {{ 'general.date' | translate }}
                    </div>

                    <!-- COLUMN SORT && FILTER ICONS -->
                    <div class='d-flex align-items-center h-100'>
                        <p-sortIcon field='date'></p-sortIcon>
                    </div>

                </div>
            </th>

            <!-- DELETE -->
			<th class="button-column"></th>

        </tr>
    </ng-template>
    <!-- #endregion TABLE COLUMN DEFINITION -->

    <!-- #region TABLE BODY -->
    <ng-template pTemplate="body" let-sinisterObservations>
        <tr class="p-selectable-row custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)="editDialog(sinisterObservations)">

            <!-- DESCRIPTION -->
            <td>
                {{ sinisterObservations.description }}
            </td>

            <!-- DATE -->
            <td>
                {{ sinisterObservations.date | date: 'dd/MM/yyyy'}}
            </td>

            <!-- DELETE -->
			<td>
				@if (isDeleteGranted) {
				<button type="button" class="btn custom-table-remove-button" (click)="onDeleteObservation(sinisterObservations)">
					<svg-icon
						src="assets/icons/trash.svg"
						class="d-flex flex-wrap custom-table-remove-button-icon"
						[svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
					></svg-icon>
				</button>
				}
			</td>
        </tr>

    </ng-template>
    <!-- #endregion TABLE BODY -->

    <!-- #region TABLE EMPTY MESSAGE -->
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="3" class="p-0">
                <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
                    {{ 'table.tableEmptyMessage' | translate }}!
                </div>
            </td>
        </tr>
    </ng-template>
    <!-- #endregion TABLE EMPTY MESSAGE -->

    <!-- #region TABLE FOOTER -->
    <ng-template pTemplate="footer">
        <tr>
            <td colspan="3" class="p-0">
                <div class="d-flex flex-row align-items-center p-3 gap-3">

                    <!-- ADD accessory BUTTON -->
                    @if (isCreateGranted) {
                    <app-table-add-button
                        [text]=" 'tableManagement.sinister.sinisterObservations' | translate"
                        (btnClick)="create()"></app-table-add-button>
                    }

                    <!-- EXCEL BUTTON -->
                    <app-table-excel-button class="buttonTableExcel"
                        (btnClick)="exportExcel()"></app-table-excel-button>
                </div>
            </td>
        </tr>
    </ng-template>
    <!-- #endregion TABLE FOOTER -->

</p-table>



<!-- SINISTER OBSERVATIONS FORM -->
<app-observations-form [type]="type" [id]="entityId" (saveCompleted)="onSaveCompleted($event)"></app-observations-form>

<p-confirmDialog
	#saveEventDialog
	[header]="'confirm.critic' | translate"
	[message]="'control-panel.delete-dialog.message' | translate"
	class="custom-dialog"
	icon="pi pi-exclamation-triangle"
	key="observations-list"
>
	<ng-template pTemplate="footer">
		<!-- REJECT BUTTON -->
		<button (click)="saveEventDialog.onReject()" class="custom-button">
			{{ 'general.no' | translate }}
		</button>
		<!-- ACCEPT BUTTON -->
		<button (click)="saveEventDialog.onAccept()" class="custom-button">
			{{ 'general.yes' | translate }}
		</button>
	</ng-template>
</p-confirmDialog>